var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11800_1469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40057 15.3874C3.47432 13.7831 4.02549 11.7261 5.6298 10.7998L9.38258 8.63315L8.35341 6.85059L4.60064 9.01725C2.01122 10.5123 1.123 13.8271 2.618 16.4166C4.113 19.006 7.42789 19.8942 10.0173 18.3992L13.7701 16.2325L12.7409 14.45L8.98814 16.6166C7.38383 17.5429 5.32682 16.9917 4.40057 15.3874ZM8.78883 14.1048L16.2944 9.77142L15.2111 7.89503L7.7055 12.2284L8.78883 14.1048ZM13.9826 3.60059L10.2298 5.76725L11.259 7.54982L15.0117 5.38316C16.6161 4.4569 18.6731 5.00808 19.5993 6.61239C20.5256 8.2167 19.9744 10.2737 18.3701 11.2L14.6173 13.3666L15.6465 15.1492L19.3992 12.9825C21.9887 11.4875 22.8769 8.17264 21.3819 5.58322C19.8869 2.99381 16.572 2.10559 13.9826 3.60059Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11800_1469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2ca0ad572d5e49b678b4bb85f530a1b5.svg";
export { ForwardRef as ReactComponent };